export default __webpack_public_path__ + "static/media/shape_bottom_.5d80beb7.webp";